export default __webpack_public_path__ + "static/fb@2x-cbc8260344999d64b147168c9c1d6daa.jpg";